package nl.volleyanalyzer.web.controller

import kotlinx.html.FlowContent
import kotlinx.html.classes
import kotlinx.html.span
import kotlinx.html.strong
import nl.volleyplanner.api.sports.Match
import nl.volleyplanner.api.sports.TeamIdentifier
import nl.volleyplanner.api.sports.TeamMatchResult
import nl.volleyplanner.web.base.component.badge
import nl.volleyplanner.web.util.BootstrapColor

fun FlowContent.matchSetResultBadge(match: Match, teamIdentifier: TeamIdentifier) {
    val bgColor = when (match.getTeamResult(teamIdentifier)) {
        TeamMatchResult.Win -> BootstrapColor.Success
        TeamMatchResult.Lose -> BootstrapColor.Danger
        TeamMatchResult.Tie -> BootstrapColor.Warning
    }
    badge(bgColor) {
        strong {
            +"${match.getSets(teamIdentifier)} - ${match.getSets(!teamIdentifier)}"
        }
    }
}

fun FlowContent.setResultsBadges(match: Match, teamIdentifier: TeamIdentifier) {
    span(classes = "small") {
        match.setResults?.forEach { setResult ->
            val teamPoints = setResult.getPoints(teamIdentifier)
            val opposingPoints = setResult.getPoints(!teamIdentifier)
            val badgeBgColor = when (setResult.getTeamResult(teamIdentifier)) {
                TeamMatchResult.Win -> BootstrapColor.Success
                TeamMatchResult.Lose -> BootstrapColor.Danger
                TeamMatchResult.Tie -> BootstrapColor.Warning
            }
            badge(badgeBgColor, small = true) {
                classes += "me-1"
                +"$teamPoints - $opposingPoints"
            }
        }
    }
}